import { useEffect } from "react";

import { useCaptionsUnavailable } from "@/features/tutor/hooks/useCaptionsUnavailable";
import { useChatSettingsStore } from "@/features/tutor/store/useChatSettingsStore";

export const useCaptionsAvailabilitySync = (): void => {
  const unavailable = useCaptionsUnavailable();
  const setCaptionsAvailable = useChatSettingsStore(
    (state) => state.setCaptionsAvailable,
  );

  useEffect(() => {
    setCaptionsAvailable(!unavailable);
  }, [unavailable, setCaptionsAvailable]);
};
